import {
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link } from "react-router-dom";
import { grey } from "@mui/material/colors";

const AuthorizationMenu = ({
  open,
  selectedMenu,
  handleMenuClick,
  isMobile,
  theme,
  sideAuthorizationData
}) => {

  return (
    <>
      { sideAuthorizationData?.map((res, id) => {
            return (
              <Link key={id} to={{ pathname: res?.route, state: res?.state}}>
              {res?.show && 
                <ListItem
                  key={id}
                  disablePadding
                  sx={{ display: 'block', fontSize: "12px", marginLeft: 0}}
                  onClick={(e) => (handleMenuClick(res?.label))}
                >
                  <ListItemButton
                    selected={selectedMenu === res?.label}
                    key={id}
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor:
                          theme?.palette?.primary?.main + "20",
                      },
                      borderRadius: "8px",
                      fontWeight: 600,
                      minHeight: 44,
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: open ? "flex-start" : "center",
                      gap: open ? 2 : 0, // Use gap instead of margin-right
                      padding: open ? "8px 12px" : "8px", // Simplified padding
                      transition: "all 0.3s ease",
                    }}
                  >
                    <ListItemIcon
                      key={id}
                      sx={{
                      minWidth: 0,
                      width: open ? "auto" : "24px", // Fixed width for icon when closed
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.3s ease",
                      "& svg": {
                        fontSize: "20px",
                        transition: "all 0.3s ease",
                      },
                    }}
                    >
                      <span
                        style={{
                          color:
                            selectedMenu === res?.label
                              ? theme?.palette?.primary?.main
                              : theme.palette.mode === "dark"
                              ? theme.palette.text.primary
                              : theme.palette.text.secondary,
                          transition: "color 0.3s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {res?.icon}
                      </span>
                    </ListItemIcon>

                    {open && (
                      <ListItemText
                        primaryTypographyProps={{
                          variant: "body2",
                          fontWeight:
                            selectedMenu === res?.label ? 600 : 550,
                          fontSize: "0.8rem",
                          color:
                            selectedMenu === res?.label
                              ? "primary"
                              : grey[600],
                        }}
                        primary={res?.label}
                        sx={{
                          flex: 1, // Take remaining space
                          margin: 0, // Remove default margins
                          pl: "3px"
                        }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              }
              </Link>
            )
          })
        }
    </>
  );
};

export default AuthorizationMenu;
